import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=b00a800c&scoped=true&"
import script from "./quotation.vue?vue&type=script&lang=js&"
export * from "./quotation.vue?vue&type=script&lang=js&"
import style0 from "./quotation.vue?vue&type=style&index=0&id=b00a800c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00a800c",
  null
  
)

export default component.exports